<template>
    <div class="body">
        <p  class="font1" style="padding-top: 13vh;">不积跬步无以至千里，</p>
        <p  class="font1" style="padding-top: 1vh;">不积小流无以成江海。</p>

        <p  class="font2" style="padding-top: 5vh;">推荐书籍如下：</p>

        <div class="wrapper">
            <div class="bookTextOne">
                <h3>《创新之力》</h3>
                <div id="qiymet2" @click="openPDF(2)">
                    <p>
                        <i class="fa fa-eye fa-2x"></i>
                    </p>
                </div>
                <p style="padding-bottom: 4px;width: 100%;">作者:[英]Matt Kingdon(马特金登)</p>
               
            </div>
            <div class="bookTextTwo">
                <h3>《创新的天梯》</h3>
                <div id="qiymet1" @click="openPDF(1)">
                    <p>
                        <i class="fa fa-eye fa-2x"></i>
                    </p>
                </div>
                <p style="padding-bottom: 4px;width: 100%;">作者：[以]亚里拉登伯格(Arie Ruttenberg)<br>[加]夏罗默迈特尔(Shlomo Maital)</p>  
            </div>
        </div>
        <div class="dialog" v-show="bookShow">        
            <i style="margin-left:95%;color: #090808;" @click="bookShow = false" class="fa fa-close fa-1x"></i>
            <div v-if="this.bookPage==1" style="text-align: justify;width: 100%;">
              <div style="width: 90%;margin: 0 auto;">
                  这是一本故事书，却全面地解答了创新研究领域最难的问题“How to do”。<br><br>  
                  “创新不是技术，是艺术”，技术有界，艺术无边；技术是有明确规则和边界的一系列标准规范，而每一次创新都是打破现有标准规范的一场革命。推拉推创新方法能让每一个人，在理性标准的三步之内，身在凡世，思维无疆；打破边界，实现创新。<br><br>  
                  神奇吗？读完本书，你会觉得，下一个创新，已经离你不远……<br><br>  
                  <p style="font-size: 15px; color: chocolate;">*详情请登录富学宝典上搜索“创新的天梯”查看！</p>
              </div>
            </div>
            <div v-if="this.bookPage==2" style="text-align: justify;">
              <div style="width: 90%;margin: 0 auto;">
                《创新之力——将创意变为现实》是关于组织创新者激活创新精神的终极操作指南！讲述了大企业中平凡英雄们的创新故事。本书深入挖掘如何才能使创新在那些运行思维模式已根深蒂固的公司里真正实现。<br><br>
                本书包含一系列的观察，探讨人们在组织中如何做出努力以将看似毫无关联的东西融会贯通，努力推进，从而实现创新。更重要的是，书中也提供了实用的步骤教你如何获得“好运气”来发现工作中的下一个“新大陆”。<br><br>
                  <p style="font-size: 15px; color: chocolate;">*详情请登录富学宝典上搜索“创新之力”查看！</p>
              </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
  props: {
    ReportData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      widthWindow: window.innerWidth, 
      widthBlock: window.innerWidth*0.47,
      heightBlock: window.innerHeight*0.257,
      bookPage: 1,
      bookId: 0,
      bookShow: false,
    }
  },
  created() {
    
  },
  methods: {
    openPDF(bookPage) {
      if(bookPage === 1){
        this.bookPage = 1
        this.bookId = 1
      } else {
        this.bookPage = 2
        this.bookId = 2
      }
      this.bookShow = true
    },
  }
}
</script>
  
  <style scoped>
  .body {
      background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                  url("../../assets/24April/logo.png") right  top  no-repeat,
                  url("../../assets/24April/bg1.jpg")  no-repeat;
      background-size: 17% 8%,110px 35px,cover;
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;  
      align-items: center;  
  }
  .font1 {
      width: 80%;
      margin: 0;
      /* text-align: center; */
      font-size: 20px;
      color: #70b787;
      font-weight: bold;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font2 { 
      width: 80%;
      margin: 0 auto;
      padding: 0;
      color: #000;
      font-size: 20px;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font3 {
      font-size: 20px;
      font-weight: bold;
      color: #36854f;
      text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .dialog {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      z-index: 2000;
      /* bottom: 20%; */
      width: 91%;
      height: auto;
      background: #fff;
      border-radius: 7px;
      padding: 7px;
      box-shadow: #eae62ebd 1px;
  }

  .fa {
      color: #fff8e8;
  }


  .wrapper {
      z-index: 1000;
      width: 97%;
      /* height: auto; */
      height: 40vh;
      display: flex;
      justify-content: center;
      background-color: rgba(255, 255, 255, 0.5);
      border-radius: 10px;;
      border-radius: 17px;
      margin: 0 auto;
      flex-wrap: wrap;
  }

  .bookOne {
      width: 30%;
      height: 20%;
      /* margin-top: 10px; */
  }

  .bookTwo {
      width: 30%;
      height: 20%;
  }

  .bookTextOne {
      margin-left: 11px;
      width: 90%;
      height: 90px;
      color: #000;
  }
  .bookTextTwo {
      margin-left: 11px;
      width: 90%;
      height: 130px;
      color: #000;
    }

    #qiymet2 {
      float: right;
      margin-right: 20px;
      margin-top: -35px;
      padding: 0px 17px 0px 17px;
      border-radius: 20px;
      color: #000;
      font-family: 'Source Code Pro', cursive;
      background-color: rgb(39, 178, 217);
  }

  #qiymet1 {
      float: right;
      margin-right: 20px;
      margin-top: -35px;
      padding: 0px 17px 0px 17px;
      /* width: 51px;
      height: 51px; */
      border-radius: 20px;
      color: #000;
      font-family: 'Source Code Pro', cursive;
      background-color: rgb(39, 178, 217);
      z-index: 1000;
  }

  .zezhao {
      width: 100%;
      height: 100%;
      background: #000000bc;
      z-index: 1920;
      position: absolute;
  }

  button {
      border: none;
      outline: none;
      background-color: rgb(39, 178, 217);
      padding: 10px 20px;
      font-size: 12px;
      font-weight: 700;
      color: #fff;
      border-radius: 5px;
      transition: all ease 0.1s;
      box-shadow: 0px 5px 0px 0px rgb(116, 219, 247);
      margin: 5px;
  }

  button:active {
      transform: translateY(5px);
      box-shadow: 0px 0px 0px 0px rgb(116, 219, 247);
  }

  .donghua{
      animation:flash 3s infinite
    }
    @keyframes flash {
      0% {
        opacity: 0;
      }
      80% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
  }
  </style>